<script>
  import { activeRoute } from '@/router/Router.svelte';
  import Link from '@/elements/Actions/Links/Basic.svelte';
  export let navs;
</script>

<nav class="hidden md:flex space-x-6">
  {#if $activeRoute.path === '/'}
    {#each navs as nav}
      <Link {nav}>{nav.id}</Link>
    {/each}
  {:else}
    <a href="/" class="border-transparent text-white hover:border-warm-300 hover:text-warm-100 border-b-2 text-xs font-medium">
      <p>Return to Homepage</p>
    </a>
  {/if}
</nav>
